import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from '../app-config';
import { buildFormData } from '../utils';
import { IImageRepository } from './Iimage.repository';
import { ApiResponse, Image, ImageCategorizationSave, ImageThumb } from './models';


@Injectable({ providedIn: 'root' })
export class ImageRepository implements IImageRepository {

	constructor(private readonly http: HttpClient, @Inject(APP_CONFIG) private readonly config: AppConfig) { }

	uploadImage(imageData: ImageCategorizationSave, image: File): Observable<ApiResponse<Image>> {
		const formData = new FormData();
		buildFormData(formData, imageData);
		formData.append('image', image);
		return this.http.post<ApiResponse<Image>>(this.config.domainImageAPI + '/api/Images/Upload', formData);
	}

	getImageDetail(image: string, user: string): Observable<ApiResponse<Image>> {
		const params = new HttpParams().set('image', image).set('user', user);
		return this.http.get<ApiResponse<Image>>(this.config.domainImageAPI + '/api/Images/Detail', { params });
	}

	getThumbnails(patientGuid: string, userId: string, imageGuids: string[]): Observable<ApiResponse<ImageThumb[]>> {
		let params = new HttpParams().set('patient', patientGuid).set('userId', userId);
		for (const id of imageGuids) {
			params = params.append('imageGuid', id);
		}
		return this.http.get<ApiResponse<ImageThumb[]>>(this.config.domainImageAPI + '/api/Images/ThumbList', { params });
	}

	getImage(id: string): Observable<Blob> {
		const params = new HttpParams().set('resourceId', id);
		return this.http.get(this.config.domainImageAPI + `/api/archive/GetImage`, { params, responseType: 'blob' });
	}

	getViewCase(id: string): Observable<Blob> {
		const params = new HttpParams().set('resourceId', id);
		return this.http.get(this.config.domainImageAPI + `/api/archive/GetViewCase`, { params, responseType: 'blob' });
	}

}
